export default __webpack_public_path__ + "static/media/tut-dashboard.7e9df781.jpg";